import { prompt } from '../../../lib/bootbox'
import { slugify } from '../../../lib/transliterate/slugify'

export const suggestCaseSubdialogId = (
  stepId: string,
  title: string | undefined,
  caseTitle: string | undefined,
  caseIndex: number
): string => {
  return [slugify(title) || slugify(stepId), slugify(caseTitle) || caseIndex]
    .filter(item => item || item === 0)
    .join('-')
}

export async function getPromptedTitleAndValue(
  title?: string,
  value?: string
): Promise<{ title?: string; value?: string } | undefined> {
  const promptTitle = await prompt({ title: "What's the title?", value: title })
  if (!promptTitle) {
    return
  }

  const promptValue = await prompt({ title: "What's the value?", value })
  if (!promptValue) {
    return
  }

  return { title: promptTitle, value: promptValue }
}

export async function getDefaultCaseTitle(title: string): Promise<string | undefined> {
  const promptTitle = await prompt({ title: "What's the default case title?", value: title })
  if (!promptTitle) {
    return
  }

  return promptTitle
}
